import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import LogoSrc from '@/assets/mobileLogo.png';

const Loading: React.FC = () => {
  const groupRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 1) Fade out the logo completely after 3s
    gsap.to(logoRef.current, {
      autoAlpha: 0,
      delay: 5,
      duration: 0.5,
      ease: 'power1.out',
    });

    // 2) Stripes slide back-and-forth, starting after 3s
    gsap.fromTo(
      groupRef.current,
      { xPercent: 100 },
      {
        xPercent: -200,
        delay: 3,
        duration: 5,
        ease: 'power2.inOut',
        repeat: -1,
        yoyo: true,
        repeatDelay: 0,
      }
    );
  }, []);

  return (
    <div className="tw-relative tw-min-h-screen tw-bg-black tw-overflow-hidden">
      {/* Logo Overlay */}
      <div 
        ref={logoRef}
        className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-z-50"
      >
        <img 
          src={LogoSrc} 
          alt="Loading Logo" 
          className="tw-w-32 tw-h-auto tw-object-contain"
        />
      </div>

      {/* Connected overlay stripes */}
      <div
        ref={groupRef}
        className="tw-absolute tw-top-0 tw-left-0 tw-flex tw-h-full"
        style={{ width: '300vw', zIndex: 10 }}
      >
        <div className="tw-w-screen tw-h-full tw-bg-cyan-500" />
        <div className="tw-w-screen tw-h-full" style={{ backgroundColor: '#5886f9' }} />
        <div className="tw-w-screen tw-h-full tw-bg-emerald-400" />
      </div>
    </div>
  );
};

export default Loading;
